import { Component, ChangeDetectorRef, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, inject } from '@angular/core';
import { ContextMenuPRCFINComponent } from '../context-menu-prcfin/context-menu-prcfin.component';
import Swal from 'sweetalert2';
import { User_CDMS, User_CDMS_Not_Dup } from 'src/app/Interfaces/Interfaces-Global/User_CDMS.interface';
import { firstValueFrom, Subscription } from 'rxjs';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Update_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Create_WF/Update_FIN.interface';
import { Data_Approver, FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { Data_VH_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_VH_FIN.interface';
import { FormGroup } from '@angular/forms';
import { Permission_Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { Validators } from '@angular/forms';
import { Annexes_Current_Last, Annexes_Current_Last_Data, FILE_CAP_Annexe_ID, FILE_CAP_Annexe_Update } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { FormTemplateService } from 'src/app/Services/Forms/form-template.service';
import { FormModalService } from 'src/app/Services/Forms/form-modal.service';
import { Form_Submission, Form_Template_With_Fields, Response_Forms } from 'src/app/Interfaces/Forms/FormTemplate.interface';

@Component({
    selector: 'app-properties-proc-fin',
    templateUrl: './properties-proc-fin.component.html',
    styleUrls: ['./properties-proc-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css'],
    standalone: false
})
export class PropertiesProcFINComponent extends ContextMenuPRCFINComponent implements OnChanges {

  private readonly ReviewerHeaderKeys: string[] = ['APPR1', 'APPR2', 'APPR3', 'APPR4'];

  // Form submission
  private formTemplateService = inject(FormTemplateService);
  private formModalService = inject(FormModalService);
  private cdr = inject(ChangeDetectorRef);
  private formModalSub: Subscription | null = null;
  public FormSubmission: any = null;
  public FormTemplate: Form_Template_With_Fields | null = null;
  public HasFormSubmission: boolean = false;
  public CanEditProperties: boolean = true;

  @Input() override FILE_FIN_Properties!: Data_VH_FIN;
  @Input() override FormFINProperties!: FormGroup;
  @Input() override FFIN_Select_CM!: FILE_FIN;
  @Input() override All_FAF_FIN!: FILE_FIN[];
  @Input() override FileAuxPropeties_Anne!: FILE_CAP_Annexe_ID[];
  @Input() override Permission_FMF!: Permission_Folder_FIN;

  @Output() IsPropertiesFIN = new EventEmitter<boolean>();
  @Output() IsAnnexeUpdaFIN = new EventEmitter<boolean>();

  @ViewChild('PropertiesFileAnnexe')
  MyInputPropertiesFileAnnexe!: ElementRef;

  @ViewChild('UpdFile_Properties_Annexe')
  MyInputUpdFile_Properties_Annexe!: ElementRef;

  // ======================== FORM SUBMISSION ========================

  override ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    this.CheckEditPermissions();
    if (changes['FILE_FIN_Properties'] && this.FILE_FIN_Properties?.ID) {
      console.log('[DEBUG FIN Properties] FILE_FIN_Properties:', this.FILE_FIN_Properties);
      this.NormalizeNullApprovers();
      this.LoadFormSubmission();
    }
  }

  public CheckEditPermissions(): void {
    if (!this.Permission_FMF || !this.Permission_FMF.Permission) {
      this.CanEditProperties = false;
      return;
    }

    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN]);
    const HasPropertiesPermission = this.Permission_FMF.Permission.includes(this.PermissionFIN.properties);

    this.CanEditProperties = IsAdmin || HasPropertiesPermission;

    // Si no puede editar, nos aseguramos que el formulario esté deshabilitado
    if (!this.CanEditProperties && this.FormFINProperties) {
      this.FormFINProperties.disable({ emitEvent: false });
    } else if (this.CanEditProperties && this.FormFINProperties) {
      this.FormFINProperties.enable({ emitEvent: false });
    }
  }

  private NormalizeNullApprovers(): void {
    const normalize = (task: Data_Approver | null | undefined): Data_Approver => ({
      ID: task?.ID ?? 0,
      ID_WF: task?.ID_WF ?? this.FILE_FIN_Properties.ID,
      ID_Involved_User: task?.ID_Involved_User ?? -1,
      ID_UR: task?.ID_UR ?? 0,
      Status: task?.Status ?? 0,
      Comment: task?.Comment ?? null,
      Date_Start: task?.Date_Start ?? null,
      Date_End: task?.Date_End ?? null
    });

    this.FILE_FIN_Properties = {
      ...this.FILE_FIN_Properties,
      TaskApprover1: normalize(this.FILE_FIN_Properties.TaskApprover1),
      TaskApprover2: normalize(this.FILE_FIN_Properties.TaskApprover2),
      TaskApprover3: normalize(this.FILE_FIN_Properties.TaskApprover3),
      TaskApprover4: normalize(this.FILE_FIN_Properties.TaskApprover4),
      Annexes: Array.isArray(this.FILE_FIN_Properties.Annexes) ? this.FILE_FIN_Properties.Annexes : []
    };
  }

  private LoadFormSubmission(): void {
    this.HasFormSubmission = false;
    this.FormSubmission = null;
    this.FormTemplate = null;

    if (!this.FILE_FIN_Properties?.ID) return;

    console.log('[Properties] Loading form submission for WF ID:', this.FILE_FIN_Properties.ID);
    this.formTemplateService.GetSubmissionByWorkflow(this.FILE_FIN_Properties.ID, 'FIN').subscribe({
      next: (res: Response_Forms) => {
        console.log('[Properties] Submission response:', res.success, res.operation);
        if (res.success && res.operation && res.operation.ID) {
          this.FormSubmission = res.operation;
          this.HasFormSubmission = true;
          try { this.cdr.detectChanges(); } catch (e) {}
          // Force re-render after modal animation completes
          setTimeout(() => {
            this.HasFormSubmission = true;
            try { this.cdr.detectChanges(); } catch (e) {}
          }, 600);
          // Load the template with fields
          this.formTemplateService.GetFormTemplateById(this.FormSubmission.ID_Form_Template).subscribe({
            next: (res2: Response_Forms) => {
              if (res2.success) {
                this.FormTemplate = res2.operation;
                this.cdr.detectChanges();
              }
            }
          });
        } else {
          this.HasFormSubmission = false;
          this.FormSubmission = null;
          this.FormTemplate = null;
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.HasFormSubmission = false;
      }
    });
  }

  public IsReviewerAssigned(index: number): boolean {
    const task = (this.FILE_FIN_Properties as any)[`TaskApprover${index}`];
    return task && task.ID_Involved_User > 0;
  }

  public HasReviewers(): boolean {
    return this.IsReviewerAssigned(1) ||
      this.IsReviewerAssigned(2) ||
      this.IsReviewerAssigned(3) ||
      this.IsReviewerAssigned(4);
  }

  public EditFormSubmission(): void {
    if (!this.FormTemplate) return;

    // Build preload values from submission
    const preload: { [fieldId: number]: string | null } = {};
    if (this.FormSubmission?.Values) {
      for (const v of this.FormSubmission.Values) {
        preload[v.ID_Field] = v.Value;
      }
    }

    // Listen for result
    this.formModalSub?.unsubscribe();
    this.formModalSub = this.formModalService.result$.subscribe((result) => {
      if (result.confirmed && this.FormSubmission) {
        // Update submission
        this.formTemplateService.UpdateSubmission(this.FormSubmission.ID, {
          Values: result.values
        }).subscribe({
          next: (res: Response_Forms) => {
            if (res.success) {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Formulario actualizado',
                showConfirmButton: false,
                timer: 1500
              });
              this.LoadFormSubmission();
            }
          },
          error: () => {
            Swal.fire('Error', 'No se pudo actualizar el formulario.', 'error');
          }
        });
      }
      this.formModalSub?.unsubscribe();
    });

    this.formModalService.open(this.FormTemplate, preload);
  }

  public GetSubmissionValueByLabel(label: string): string {
    if (!this.FormSubmission?.Values) return '—';
    const val = this.FormSubmission.Values.find((v: any) => v.Label === label);
    return val?.Value || '—';
  }

  public FormatDateValue(value: string | null): string {
    if (!value) return '—';
    try {
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) {
      return value;
    }
  }

  public GetTableRowCount(value: string | null): number {
    if (!value) return 0;
    try {
      const rows = JSON.parse(value);
      return Array.isArray(rows) ? rows.length : 0;
    } catch (e) {
      return 0;
    }
  }

  public IsDirectMultipleLoad(): boolean {
    const purpose: string = String(this.FILE_FIN_Properties?.Purpose || '').trim().toUpperCase();
    return purpose === 'DIRECT MULTIPLE LOAD' || purpose === 'DIRECT MASSIVE LOAD';
  }

  public GetReviewerOrder(keyHeader: string): number {
    const defaultOrder: Record<string, number> = { APPR1: 1, APPR2: 2, APPR3: 3, APPR4: 4 };
    const header = this.FIN_Table_Headers.find((item) => item.Key_Header === keyHeader);
    return header?.Position ?? defaultOrder[keyHeader] ?? 999;
  }

  public GetReviewerHeaderName(keyHeader: string, fallback: string): string {
    const header = this.FIN_Table_Headers.find((item) => item.Key_Header === keyHeader);
    return header?.Name?.trim() || fallback;
  }

  public ShowReviewerBlock(keyHeader: string): boolean {
    if (this.IsDirectMultipleLoad()) {
      return false;
    }

    const header = this.FIN_Table_Headers.find((item) => item.Key_Header === keyHeader);
    return header ? header.Visible : true;
  }

  public override EnaOrDis_Optional_Reviewers() {

    if (this.IsDirectMultipleLoad()) {
      this.FormFINProperties.controls['Approver1'].removeValidators(Validators.required);
      this.FormFINProperties.controls['Approver2'].removeValidators(Validators.required);
      this.FormFINProperties.controls['Approver3'].removeValidators(Validators.required);
      this.FormFINProperties.controls['Approver4'].removeValidators(Validators.required);

      this.FormFINProperties.get('Approver1')?.updateValueAndValidity();
      this.FormFINProperties.get('Approver2')?.updateValueAndValidity();
      this.FormFINProperties.get('Approver3')?.updateValueAndValidity();
      this.FormFINProperties.get('Approver4')?.updateValueAndValidity();
      return;
    }

    const isApproved = this.FILE_FIN_Properties?.Status === 1;
    const isDraft = this.FILE_FIN_Properties?.Status === 0;

    for (let i = 1; i <= 4; i++) {
      const key = `APPR${i}`;
      const control = this.FormFINProperties.controls[`Approver${i}`];

      // Si está aprobado o NO está asignado y no es borrador, quitar validadores
      if (isApproved || (!this.IsReviewerAssigned(i) && !isDraft) || !this.ShowReviewerBlock(key)) {
        control.clearValidators();
      } else {
        // Lógica original de requeridos
        if (this.Permission_FMF.Folder.Optional_Approvers === 0) {
          control.setValidators(Validators.required);
        } else {
          const groupInfo = (this.Permission_FMF.Users_Groups_For_Role as any)[`G_Approvers_${i}`]?.gApproverFolderFIN;
          if (groupInfo && !groupInfo.Required_RG) {
            control.removeValidators(Validators.required);
          } else {
            control.setValidators(Validators.required);
          }
        }
      }
    }

    this.FormFINProperties.get('Approver1')?.updateValueAndValidity();
    this.FormFINProperties.get('Approver2')?.updateValueAndValidity();
    this.FormFINProperties.get('Approver3')?.updateValueAndValidity();
    this.FormFINProperties.get('Approver4')?.updateValueAndValidity();

  }

  // ============== FUNCTION CHECK EDIT TASK ==============\\
  public CheckEditTask(Reviwer: Data_Approver | null, Status: number): boolean {

    if (Status !== 2 || Reviwer === null) {
      return false;
    }
    if (Reviwer.Status === 1 || Reviwer.Status === 2 || Reviwer.Status === 0) {
      return true;
    }
    return false;
  }

  // ============== FUNCTION STATUS TASK ==============\\
  public Check_Status_Task_Icon(Reviwer: Data_Approver | null): number {
    if (Reviwer === null) {
      return 0;
    } else {
      return Reviwer.Status;
    }

  }

  //================== FUNCTTION FOR ADD FILE ANNEXE ==================\\
  public async Add_Document_Annexe_Properties(data: Event): Promise<void> {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {

      if (!this.FileAuxPropeties_Anne.some(item => item.FileName === file.name && item.Status != 5)) {
        const isEncrypted: boolean = await this.checkAnnexeIsEncrypted({ FileData: file, FileName: file.name })

        if (!isEncrypted) {
          this.FileAuxPropeties_Anne.push({ ID: 0, FileData: file, FileName: file.name, Extension: file.name.split('.').pop() || "", Status: 0, Consecutive: 0, UpdateAnnexe: { FileData: '', FileName: '', Extension: '' } });
          this.MyInputPropertiesFileAnnexe.nativeElement.value = null;
        } else {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Archivo protegido con contraseña',
            text: '¡No es posible cargar archivos que estén protegidos con contraseña!',
            confirmButtonColor: this.ColorConfirm
          });
          this.MyInputPropertiesFileAnnexe.nativeElement.value = null;
        }

      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'warning',
          title: 'El anexo ya está cargado'
        })
      }


    }

    this.MyInputPropertiesFileAnnexe.nativeElement.value = null;

  }

  //================== FUNCTTION FOR DELETE FILE ANNEXE ==================\\
  public Delete_Annexe_Properties(Name_Annexe: string): void {

    Swal.fire({
      title: 'Eliminar anexo',
      text: `¿Desea eliminar el anexo ${Name_Annexe}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {
        this.FileAuxUpdFIN_Annexes = this.FileAuxUpdFIN_Annexes.filter(item => item.FileName !== Name_Annexe);
      }

    }))

  }

  //================== FUNCTTION FOR DELETE ANNEXE ==================\\
  public Delete_Annexe_Properties_Modal(Name_Annexe: string): void {

    Swal.fire({
      title: 'Eliminar anexo',
      text: `¿Desea eliminar el anexo ${Name_Annexe}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {

        const Annexe_X: FILE_CAP_Annexe_ID | undefined = this.FileAuxPropeties_Anne.find(item => item.FileName === Name_Annexe);

        if (Annexe_X != undefined) {
          if (Annexe_X.ID === 0) {
            this.FileAuxPropeties_Anne = this.FileAuxPropeties_Anne.filter(item => item.FileName !== Name_Annexe);
          } else {
            this.FileAuxPropeties_Anne.forEach((item: FILE_CAP_Annexe_ID) => {
              if (item.FileName === Name_Annexe) {
                item.Status = 5;
              }
            })
          }
        }
      }

    }))

  }

  //================== FUNCTTION UPDATE ANNEXE ==================\\
  public async Annexe_Properties(Annexe: FILE_CAP_Annexe_ID): Promise<void> {

    this.Toogle_Modal_Properties_Annexe(true);

    this.FileAuxUpdFIN_Annexe_Properties = Annexe;

  }

  //================== FUNCTTION FOR OPEN OR CLOSE MODAL UPDATE ANNEXE ==================\\
  public Toogle_Modal_Properties_Annexe(CloseOrOpen: boolean): void {

    this.MyInputUpdFile_Properties_Annexe.nativeElement.value = null;
    this.FileAuxUpdFIN_Annexe_Properties = { ID: 0, FileData: '', FileName: '', Extension: '', Status: 0, Consecutive: 0, UpdateAnnexe: { FileData: '', FileName: '', Extension: '' } };

    const Modal_Properties_Annexe = document.getElementById('Modal_Properties_Annexe') as HTMLElement;
    CloseOrOpen ? Modal_Properties_Annexe.classList.add('active') : Modal_Properties_Annexe.classList.remove('active');
  }

  //================== FUNCTTION FOR ADD UPDATE ANNEXE ==================\\
  public Add_Annexe_Properties(data: Event): void {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {

      const IsExist: boolean = this.Validate_Exisit_Properties_Annexe(file);

      if (IsExist) {

        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'warning',
          title: 'El anexo de actualización ya esta cargado en otro anexo'
        })

      } else {

        for (const Annexe of this.FileAuxPropeties_Anne) {
          if (Annexe.ID === this.FileAuxUpdFIN_Annexe_Properties.ID) {
            Annexe.UpdateAnnexe = { FileData: file, FileName: file.name, Extension: file.name.split('.').pop() || '' };
            this.FileAuxUpdFIN_Annexe_Properties = Annexe; break;
          }
        }
      }

    }

    this.MyInputUpdFile_Properties_Annexe.nativeElement.value = null;

  }

  //================== FUNCTTION FOR DELETE UPLOAD ANNEXE ==================\\
  public Delete_Properties_Annexe(): void {

    Swal.fire({
      title: 'Eliminar actualización de anexo',
      text: `¿Desea eliminar la actualización del anexo ${this.FileAuxUpdFIN_Annexe_Properties.FileName}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {

        for (const Annexe of this.FileAuxPropeties_Anne) {
          if (Annexe.ID === this.FileAuxUpdFIN_Annexe_Properties.ID) {
            Annexe.UpdateAnnexe = { FileData: '', FileName: '', Extension: '' };
            this.FileAuxUpdFIN_Annexe_Properties = Annexe; break;
          }
        }
        this.Toogle_Modal_Update_Annexe(false);
      }

    }))


  }

  //================== FUNCTTION FOR VALIDATE ANNEXE ==================\\
  private Validate_Exisit_Properties_Annexe(file: File): boolean {
    for (const Annexe of this.FileAuxPropeties_Anne) {
      if (Annexe.UpdateAnnexe.FileName === file.name) {
        return true;
      }
    }
    return false;
  }

  public async SaveEditProperties(): Promise<void> {

    const Array_Task: Data_Approver[] = [];
    const IsDirectLoad: boolean = this.IsDirectMultipleLoad();

    const IsValidProperties: boolean = await this.IsValidFormFIN_Properties();

    const NewNameFIN: string = this.FormFINProperties.controls['NameFIN'].value + '.' + this.FILE_FIN_Properties.Extension;
    const NewCodeFIN: string = this.FormFINProperties.controls['Code'].value;
    const NewPurpose: string = this.FormFINProperties.controls['Purpose'].value;

    const NewApprover1: User_CDMS | null = IsDirectLoad ? null : this.FormFINProperties.controls['Approver1'].value;
    const NewApprover2: User_CDMS | null = IsDirectLoad ? null : this.FormFINProperties.controls['Approver2'].value;
    const NewApprover3: User_CDMS | null = IsDirectLoad ? null : this.FormFINProperties.controls['Approver3'].value;
    const NewApprover4: User_CDMS | null = IsDirectLoad ? null : this.FormFINProperties.controls['Approver4'].value;


    const ID_Approver1: number = (typeof NewApprover1 === 'object' && NewApprover1 !== null) ? NewApprover1.ID : -1;
    const ID_Approver2: number = (typeof NewApprover2 === 'object' && NewApprover2 !== null) ? NewApprover2.ID : -1;
    const ID_Approver3: number = (typeof NewApprover3 === 'object' && NewApprover3 !== null) ? NewApprover3.ID : -1;
    const ID_Approver4: number = (typeof NewApprover4 === 'object' && NewApprover4 !== null) ? NewApprover4.ID : -1;


    const No_Revision: number = Number(this.FormFINProperties.controls['Revision_No'].value)

    const Set_Approver1: Data_Approver = {
      ID: this.FILE_FIN_Properties.TaskApprover1.ID, ID_WF: this.FILE_FIN_Properties.TaskApprover1.ID_WF, ID_Involved_User: ID_Approver1, ID_UR: this.FILE_FIN_Properties.TaskApprover1.ID_UR, Status: this.FILE_FIN_Properties.TaskApprover1.Status, Comment: this.FILE_FIN_Properties.TaskApprover1.Comment, Date_Start: this.FILE_FIN_Properties.TaskApprover1.Date_Start, Date_End: this.FILE_FIN_Properties.TaskApprover1.Date_End
    }

    const Set_Approver2: Data_Approver = {
      ID: this.FILE_FIN_Properties.TaskApprover2.ID, ID_WF: this.FILE_FIN_Properties.TaskApprover2.ID_WF, ID_Involved_User: ID_Approver2, ID_UR: this.FILE_FIN_Properties.TaskApprover2.ID_UR, Status: this.FILE_FIN_Properties.TaskApprover2.Status, Comment: this.FILE_FIN_Properties.TaskApprover2.Comment, Date_Start: this.FILE_FIN_Properties.TaskApprover2.Date_Start, Date_End: this.FILE_FIN_Properties.TaskApprover2.Date_End
    }

    const Set_Approver3: Data_Approver = {
      ID: this.FILE_FIN_Properties.TaskApprover3.ID, ID_WF: this.FILE_FIN_Properties.TaskApprover3.ID_WF, ID_Involved_User: ID_Approver3, ID_UR: this.FILE_FIN_Properties.TaskApprover3.ID_UR, Status: this.FILE_FIN_Properties.TaskApprover3.Status, Comment: this.FILE_FIN_Properties.TaskApprover3.Comment, Date_Start: this.FILE_FIN_Properties.TaskApprover3.Date_Start, Date_End: this.FILE_FIN_Properties.TaskApprover3.Date_End
    }

    const Set_Approver4: Data_Approver = {
      ID: this.FILE_FIN_Properties.TaskApprover4.ID, ID_WF: this.FILE_FIN_Properties.TaskApprover4.ID_WF, ID_Involved_User: ID_Approver4, ID_UR: this.FILE_FIN_Properties.TaskApprover4.ID_UR, Status: this.FILE_FIN_Properties.TaskApprover4.Status, Comment: this.FILE_FIN_Properties.TaskApprover4.Comment, Date_Start: this.FILE_FIN_Properties.TaskApprover4.Date_Start, Date_End: this.FILE_FIN_Properties.TaskApprover4.Date_End
    }

    const Task_Edit: Data_Approver[] = [];

    if (!IsDirectLoad) {
      Array_Task.push(Set_Approver1, Set_Approver2, Set_Approver3, Set_Approver4);
    }

    for (const Task of Array_Task) {
      if (Task.Status === 1 || Task.Status === 2 || Task.ID_Involved_User !== -1) {
        Task_Edit.push(Task);
      }
    }

    const Annexes: FILE_CAP_Annexe_Update[] = [];

    for (const File_A of this.FileAuxPropeties_Anne) {

      if (File_A.UpdateAnnexe.FileName !== '' || File_A.Status === 5 || File_A.ID === 0) {
        Annexes.push({ ID: File_A.ID, Name: File_A.FileName, Extension: File_A.Extension, Status: File_A.Status, UpdateAnnexe: { Name: File_A.UpdateAnnexe.FileName, Extension: File_A.UpdateAnnexe.Extension } });
      }

    }

    const Send_Update_FIN: Update_FIN = {
      ID: this.FILE_FIN_Properties.ID,
      Name: NewNameFIN.trim(),
      Code: NewCodeFIN.trim(),
      Purpose: NewPurpose.trim(),
      Revision_No: No_Revision,
      Tasks: Task_Edit,
      Annexes: Annexes
    }

    const IsExisitInPath: boolean = this.Check_FIN_in_Path_Directory(NewNameFIN, this.FFIN_Select_CM.ID);

    if (IsExisitInPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'El Proceso ya existe en este directorio ',
        text: '¡No puede renombrar el Proceso con este nombre!',
        confirmButtonColor: this.ColorConfirm
      })
    } else if (!this.FormFINProperties.valid || !IsValidProperties) {
      // Re-ejecutar validación visual para mostrar campos en rojo si es necesario
      this.IsValidFormFIN_Properties();
      
      if (!this.FormFINProperties.valid) {
        Swal.fire({
          icon: 'error',
          title: 'Formulario no válido',
          text: 'Por favor, revise que todos los campos requeridos estén llenos correctamente.',
          confirmButtonColor: this.ColorConfirm
        });
      }
    } else if (this.FormFINProperties.valid && IsValidProperties) {
      Swal.fire({
        title: '¿Los datos son correctos?',
        text: `Estas modificando las propiedades de ${this.FILE_FIN_Properties.Name}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, son correctos!',
        cancelButtonText: 'No, Cancelar',
      }).then(async (result) => {

        if (result.isConfirmed) {
          try {

            const ResUpdateFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Update_Properties_FIN(Send_Update_FIN));

            if (ResUpdateFIN.success) {

              const Annexes_Last_Current_Update_Properties: Annexes_Current_Last[] = ResUpdateFIN.operation.Annexe_Update.Annexe_Update;

              await this.Send_Annexes_Update_Properties(this.FILE_FIN_Properties.ID, Annexes_Last_Current_Update_Properties);


              Swal.fire({
                icon: 'success',
                title: 'Las propiedades del Proceso se modificaron correctamente',
                confirmButtonColor: this.ColorConfirm
              })

              this.ToggleModalProperties(false);
              this.IsPropertiesFIN.emit(true);
            }

          } catch (e) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: '¡Ocurrio un error al cambiar las propiedades del Proceso, notifica a tu supervisor!',
              confirmButtonColor: this.ColorConfirm,
            })
            this.ToggleModalProperties(false);
            this.IsPropertiesFIN.emit(true);
          }
        }
      })
    }

  }

  //-================== FUNCTTION FOR SEND ANNEXES ==================-\\
  private async Send_Annexes_Update_Properties(ID_WF: number, Annexes: Annexes_Current_Last[]): Promise<boolean> {

    return new Promise((resolve, reject) => {

      const Annexes_Send: Annexes_Current_Last_Data[] = [];


      for (const Annexe of Annexes) {
        for (const Annexe_Data of this.FileAuxPropeties_Anne) {
          if (Annexe.Current_Annexe.Name === Annexe_Data.UpdateAnnexe.FileName && Annexe.Current_Annexe.Status != 5) {
            Annexes_Send.push({
              Last_Annexe: { ID: Annexe.Last_Annexe.ID, Name: Annexe.Last_Annexe.Name, Extension: Annexe.Last_Annexe.Extension, Status: Annexe.Last_Annexe.Status },
              Current_Annexe: { ID: Annexe.Current_Annexe.ID, Name: Annexe.Current_Annexe.Name, Extension: Annexe.Current_Annexe.Extension, Status: Annexe.Current_Annexe.Status, FileData: Annexe_Data.UpdateAnnexe.FileData }
            })
          }
        }
      }

      for (const Annexe of Annexes) {
        for (const Annexe_Data of this.FileAuxPropeties_Anne) {
          if (Annexe.Current_Annexe.Status === 1 && Annexe.Current_Annexe.Name === Annexe_Data.FileName && Annexe_Data.ID === 0) {
            Annexes_Send.push({
              Last_Annexe: { ID: Annexe.Last_Annexe.ID, Name: Annexe.Last_Annexe.Name, Extension: Annexe.Last_Annexe.Extension, Status: Annexe.Last_Annexe.Status },
              Current_Annexe: { ID: Annexe.Current_Annexe.ID, Name: Annexe.Current_Annexe.Name, Extension: Annexe.Current_Annexe.Extension, Status: Annexe.Current_Annexe.Status, FileData: Annexe_Data.FileData }
            })
          }
        }
      }

      const Files_Annexes = new FormData();

      Annexes_Send.forEach((file: Annexes_Current_Last_Data) => {

        if (file.Current_Annexe.FileData) {
          const Route_Saved_FIN: string = encodeURIComponent(ID_WF + '_' + file.Current_Annexe.ID + '.' + file.Current_Annexe.Extension);
          Files_Annexes.append('Files_Annexes', file.Current_Annexe.FileData, Route_Saved_FIN);
        } else {
          Swal.fire({
            title: 'Error al cargar el archivo' + file.Current_Annexe.Name,
            text: '¡informe al supervisor, de lo contrario no se podra descargar este documento!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })
        }


      })

      Files_Annexes.append('ID_WF', `${ID_WF}`);

      const Content_Progress = document.getElementById('Content-Progress-Update-Annexes-Approved') as HTMLDivElement;
      const Progress_Bar = document.getElementById('Progress-Bar-Update-Annexes-Approved') as HTMLDivElement;

      try {

        Content_Progress.classList.add('active');

        this.Service_FIN.Upload_Annexes_Update(Files_Annexes).subscribe(async (event: any) => {

          if (event.status === 500) {

            this.OnDisabled_Update_Ann_App(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            Swal.fire({
              title: 'Error en los anexos de el Proceso',
              text: '¡Ha ocurrido un error al cargar la actualización de propiedades de los anexos de el Proceso, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            this.ToggleModal_Update_Annexes_Approved(false);

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar.style.width = value + "%";
          }

          if (event['body']) {
            this.OnDisabled_Update_Ann_App(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            resolve(true);
          }

        })

      } catch (e) {

        Swal.fire({
          title: 'Error en el Proceso (Carga anexos actualización)',
          text: '¡No se guardo el archivo anexos de el Proceso en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }



    })
  }

  //-================== FUNCTION IS VALID FORM ==================-\\
  private async IsValidFormFIN_Properties(): Promise<boolean> {

    const IdInputFilePropertiesFIN = document.getElementById('IdInputFilePropertiesFIN') as HTMLElement | null;
    const IdinputCodePropertiesFIN = document.getElementById('IdinputCodePropertiesFIN') as HTMLElement | null;
    const IdinputPurpPropertiesFIN = document.getElementById('IdinputPurpPropertiesFIN') as HTMLElement | null;
    const IdinputNoRePropertiesFIN = document.getElementById('IdinputNoRePropertiesFIN') as HTMLElement | null;
    const IdInputAuA1PropertiesFIN = document.getElementById('IdInputAuA1PropertiesFIN') as HTMLElement | null;
    const IdInputAuA2PropertiesFIN = document.getElementById('IdInputAuA2PropertiesFIN') as HTMLElement | null;
    const IdInputAuA3PropertiesFIN = document.getElementById('IdInputAuA3PropertiesFIN') as HTMLElement | null;
    const IdInputAuA4PropertiesFIN = document.getElementById('IdInputAuA4PropertiesFIN') as HTMLElement | null;
    const IsDirectLoad: boolean = this.IsDirectMultipleLoad();

    if (!this.FormFINProperties.controls['NameFIN'].valid) {
      Swal.fire({
        title: '¡Nombre no valido!',
        text: `No se permiten los siguientes caracteres \\ / : * ? " < > |`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
      IdInputFilePropertiesFIN?.classList.add('ng-invalid'); IdInputFilePropertiesFIN?.classList.add('ng-touched');
      return false;
    }

    if (!this.FormFINProperties.controls['Code'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Código del proceso no valido',
        text: '¡El código del proceso es muy corto!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputCodePropertiesFIN?.classList.add('ng-invalid'); IdinputCodePropertiesFIN?.classList.add('ng-touched');
      return false;
    }

    if (!this.FormFINProperties.controls['Purpose'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Objetivo del proceso no valido',
        text: '¡El Objetivo del proceso es muy corto!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputPurpPropertiesFIN?.classList.add('ng-invalid'); IdinputPurpPropertiesFIN?.classList.add('ng-touched');
      return false;
    }

    if (!this.FormFINProperties.controls['Revision_No'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'No. Revisión no valido',
        text: '¡ingrese un numero de revisión valido, número mayor a 0!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputNoRePropertiesFIN?.classList.add('ng-invalid'); IdinputNoRePropertiesFIN?.classList.add('ng-touched');
      return false;

    }

    if (IsDirectLoad || this.FILE_FIN_Properties?.Status === 1 || this.FILE_FIN_Properties?.Status === 0) {
      return await this.Validate_Annexes_Properties();
    }

    if (this.IsReviewerAssigned(1) && !this.FormFINProperties.controls['Approver1'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario Mgr. Process Owner no valido',
        text: '¡No ha seleccionado a un Mgr. Process Owner, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuA1PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA1PropertiesFIN?.classList.add('ng-touched');
      return false;

    } else if (this.IsReviewerAssigned(1) && !(this.FormFINProperties.controls['Approver1'].value === "" || this.FormFINProperties.controls['Approver1'].value === null)) {

      const ValueApprover1: User_CDMS = this.FormFINProperties.controls['Approver1'].value;

      if (ValueApprover1.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario Mgr. Process Owner no valido',
          text: '¡Seleccione un usuario Mgr. Process Owner proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuA1PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA1PropertiesFIN?.classList.add('ng-touched');
        return false;
      }
    }

    if (this.IsReviewerAssigned(2) && !this.FormFINProperties.controls['Approver2'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario RM & ICS Specialist no valido',
        text: '¡No ha seleccionado a un RM & ICS Specialist, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuA2PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA2PropertiesFIN?.classList.add('ng-touched');
      return false;

    } else if (this.IsReviewerAssigned(2) && !(this.FormFINProperties.controls['Approver2'].value === "" || this.FormFINProperties.controls['Approver2'].value === null)) {

      const ValueApprover2: User_CDMS = this.FormFINProperties.controls['Approver2'].value;

      if (ValueApprover2.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario RM & ICS Specialist no valido',
          text: '¡Seleccione un usuario RM & ICS Specialist proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuA2PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA2PropertiesFIN?.classList.add('ng-touched');
        return false;
      }
    }

    if (this.IsReviewerAssigned(3) && !this.FormFINProperties.controls['Approver3'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario RM & ICS Sr. Mgr. no valido',
        text: '¡No ha seleccionado a un RM & ICS Sr. Mgr., por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuA3PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA3PropertiesFIN?.classList.add('ng-touched');
      return false;

    } else if (this.IsReviewerAssigned(3) && !(this.FormFINProperties.controls['Approver3'].value === "" || this.FormFINProperties.controls['Approver3'].value === null)) {

      const ValueApprover3: User_CDMS = this.FormFINProperties.controls['Approver3'].value;

      if (ValueApprover3.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario RM & ICS Specialist no valido',
          text: '¡Seleccione un usuario RM & ICS Specialist proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuA3PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA3PropertiesFIN?.classList.add('ng-touched');
        return false;
      }
    }

    if (this.IsReviewerAssigned(4) && !this.FormFINProperties.controls['Approver4'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario Director or CFO no valido',
        text: '¡No ha seleccionado a un Director or CFO, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuA4PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA4PropertiesFIN?.classList.add('ng-touched');
      return false;

    } else if (this.IsReviewerAssigned(4) && !(this.FormFINProperties.controls['Approver4'].value === "" || this.FormFINProperties.controls['Approver4'].value === null)) {

      const ValueApprover4: User_CDMS = this.FormFINProperties.controls['Approver4'].value;

      if (ValueApprover4.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario Director or CFO no valido',
          text: '¡Seleccione un usuario Director or CFO proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuA4PropertiesFIN?.classList.add('ng-invalid'); IdInputAuA4PropertiesFIN?.classList.add('ng-touched');
        return false;
      }
    }

    const Approvers: User_CDMS_Not_Dup[] = [];

    const Approver1 = this.FormFINProperties.controls['Approver1'].value;
    const Approver2 = this.FormFINProperties.controls['Approver2'].value;
    const Approver3 = this.FormFINProperties.controls['Approver3'].value;
    const Approver4 = this.FormFINProperties.controls['Approver4'].value;

    if (typeof Approver1 === "object" && Approver1 !== null) { Approvers.push({ ID: Approver1.ID, Name: Approver1.Name, ID_UR: 1 }) };
    if (typeof Approver2 === "object" && Approver2 !== null) { Approvers.push({ ID: Approver2.ID, Name: Approver2.Name, ID_UR: 2 }) };
    if (typeof Approver3 === "object" && Approver3 !== null) { Approvers.push({ ID: Approver3.ID, Name: Approver3.Name, ID_UR: 3 }) };
    if (typeof Approver4 === "object" && Approver4 !== null) { Approvers.push({ ID: Approver4.ID, Name: Approver4.Name, ID_UR: 4 }) };



    const Index_Input: number[] = [];

    for (const [index, approver] of Approvers.entries()) {
      const Approvers_Clean = [...Approvers.slice(0, index), ...Approvers.slice(index + 1, Approvers.length)]

      for (const Approver of Approvers_Clean) {
        if (Approver.ID === approver.ID) {
          Index_Input.push(Approver.ID_UR); break;
        }
      }

    }

    if (Index_Input.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuarios repetidos',
        text: '¡No puede repetir los usuarios en los campos, intente cambiar alguno usuario!',
        confirmButtonColor: this.ColorConfirm
      });

      for (const Index of Index_Input) {
        const IdInputApproverPropertiesFIN = document.getElementById(`IdInputAuA${Index}PropertiesFIN`) as HTMLElement | null;
        IdInputApproverPropertiesFIN?.classList.add('ng-invalid'); IdInputApproverPropertiesFIN?.classList.add('ng-touched');
      }

      return false;
    }


    return await this.Validate_Annexes_Properties();
  }

  //-================== FUNCTION IS VALIDATE ANNEXES ==================-\\
  private Validate_Annexes_Properties(): Promise<boolean> {

    return new Promise<any>((resolve, reject) => {

      if (this.FileAuxPropeties_Anne.length === 0) {
        Swal.fire({
          title: 'Sin anexos',
          text: "¡No adjunto anexos, ¿está seguro de enviar sin anexos?!",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: 'Sí, enviar',
          cancelButtonText: 'No, Cancelar',
        }).then((result => {
          if (result.isConfirmed) { resolve(true) } else { resolve(false) };
        }))
      } else {
        resolve(true);
      }

    })
  }

  //&===================== FUNCTIONS FOR UPDATE PROPERTIES ANNEXES FIN =====================&\\

  // ============== FUNCTION FOR OPEN OR CLOSE MODAL PROPERTIES ==============\\
  public ToggleModalPropertiesAnnexeFIN(CloseOrOpen: boolean): void {
    const ModalPropertiesAnnexeFIN = document.getElementById('ModalPropertiesAnnexeFIN') as HTMLDivElement;
    CloseOrOpen ? ModalPropertiesAnnexeFIN.classList.add('active') : ModalPropertiesAnnexeFIN.classList.remove('active');
  }

  public setAnnexeUpdate(annexe: FILE_CAP_Annexe_ID): void {
    this.annexeUpdateAux = {
      ...this.annexeUpdateAux,
      ID: annexe.ID,
      Name: annexe.FileName,
      Extension: annexe.Extension,
    };
  }

  public IsChangeAnnexeFIN(event: any) {
    if (event) {
      this.IsAnnexeUpdaFIN.emit(true);
    } else {
      Swal.fire({
        title: 'Error en el Anexo',
        text: '¡Ha ocurrido un error, informe al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
    this.ToggleModalPropertiesAnnexeFIN(false);
  }

  //&===================== END FUNCTIONS FOR UPDATE PROPERTIES ANNEXES FIN =====================&\\

  //-============== FUNCTION FOR DOWNLOAD FILE ==============-\\
  public override async DownloadFile(): Promise<void> {
    if (!this.FILE_FIN_Properties?.ID) return;

    Swal.fire({
      title: 'Descargando...',
      html: `Preparando la descarga para <b>${this.FILE_FIN_Properties.Name}</b>`,
      didOpen: () => { Swal.showLoading(); },
      allowOutsideClick: false
    });

    try {
      const res: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_FIN({ ID_FIN: this.FILE_FIN_Properties.ID, Type_D: 8 }));
      if (!res.success) {
        throw new Error('No se pudo resolver la URL de descarga.');
      }

      const url = String(res.operation?.URL_FIN || res.operation?.URL_Document || '').trim();
      if (!url) {
        throw new Error('La URL de descarga quedó vacía.');
      }

      const Name_Download: string = `${this.FILE_FIN_Properties.Name}`;

      this.Service_FIN.Download_File_FIN(url, Name_Download).subscribe({
        next: (event: any) => {
          if (event.state === "DONE") {
            Swal.close();
          }
        },
        error: (err: any) => {
          console.error(err);
          Swal.fire('Error', 'No se pudo descargar el archivo.', 'error');
        }
      });

    } catch (e) {
      console.error(e);
      Swal.fire('Error', 'Ocurrió un error al obtener la descarga.', 'error');
    }
  }

}
